import React, {PropTypes} from 'react';
import FormInput from './forminput.react';

export default class EmailInput extends FormInput {
  static propTypes = {
    action: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    inputTitle: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    value: PropTypes.string.isRequired
  }

  render() {
    const {action, name, title, inputTitle, label, value, required} = this.props;
    return (
      <div className="form-group">
        {label &&
          <label>{label}</label>
        }
        <input className="form-control"
           name={name}
           onChange={action}
           placeholder={title}
           type="email"
           required={required}
           value={value}
           title={inputTitle} />
      </div>
    );
  }
}
